import ClipLoader from 'react-spinners/ClipLoader'
import { useState } from 'react'
import { useForm } from 'react-hook-form'
import Password from '@components/Form/Inputs/Password'
import useSubmit from '@components/Form/utils/hooks/useSubmit'
import styles from '@components/Account/ForgotPasswordForm.module.scss'
import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import validation from './utils/validation'
import { useRouter } from 'next/router'

const schema = yup.object().shape({
  currentPassword: yup.string().required('Current Password Required'),
  newPassword: validation.password,
  confirmPassword: validation.verifyString('newPassword'),
})

const schemaWithHash = yup.object().shape({
  password: validation.password,
  confirmPassword: validation.verifyString('password'),
})

const ResetPassword = () => {
  const {
    query: { hash },
  } = useRouter()
  const [notification, setNotification] = useState<any>('')
  const methods = useForm({
    resolver: yupResolver(hash ? schemaWithHash : schema),
  })
  const { handleSubmit, reset } = methods

  const { onSubmit, isLoading, serverError } = useSubmit({
    endpoint: hash ? '/bidder/submitResetPassword' : '/bidder/resetPassword',
    onSuccess: ({ data }) => {
      reset()
      setNotification(data)
    },
    extraData: { hash },
  })

  return (
    <div
      className={`${styles.form_block} mx-auto flex w-full items-center flex-col mobile-padding`}
    >
      <h2 className={`${styles.forgot_password_title} font-bold`}>
        Reset Password
      </h2>
      <div className="w-full">
        <div
          className={`${!notification.message ? 'hidden' : ''} ${
            notification.success
              ? 'bg-bidfta-blue-dark'
              : styles.notification_error
          } md:mx-7 mb-7 py-3 px-9 rounded-md text-white font-bold text-center`}
        >
          {notification.message}
        </div>
      </div>
      <form
        onSubmit={handleSubmit(onSubmit)}
        className={`bg-white p-6 flex flex-col gap-4 rounded-lg border-2 border-bidfta-gray-border w-full max-w-md`}
      >
        {!hash && (
          <Password
            {...methods}
            name={'currentPassword'}
            label={'Current password'}
            required
          />
        )}
        <Password
          {...methods}
          name={hash ? 'password' : 'newPassword'}
          label={'New Password'}
          helperText={
            '(Minimum of 8 characters with 1 uppercase, 1 lowercase, 1 number and NO space)'
          }
        />
        <Password
          {...methods}
          name={'confirmPassword'}
          label={'Confirm New Password'}
        />
        <div>
          <label>
            {serverError && (
              <p className="text-red text-sm mt-2">{serverError}</p>
            )}
          </label>
          <button
            type="submit"
            disabled={isLoading}
            className=" flex justify-center items-center text-center font-bold rounded-md px-4 border bg-bidfta-blue-light border-bidfta-blue-light text-white
                hover:text-bidfta-blue-light hover:border-bidfta-blue-light
                focus:border-bidfta-blue-light hover:bg-white focus:text-bidfta-blue-light
                focus:bg-white w-full py-2.5 text-10 md:text-xs transition duration-300 ease-in-out"
          >
            {isLoading ? (
              <ClipLoader loading={isLoading} size={25} color={'#FFDF1B'} />
            ) : (
              'Reset Password'
            )}
          </button>
        </div>
      </form>
    </div>
  )
}

export default ResetPassword
